export default __webpack_public_path__ + "static/media/Flag of Dominica.38bdf171.gif";